import React from 'react';
import PropTypes from 'prop-types';
import { TRANSLATE_PREFIX } from '../../consts';
import Input from '../Input';
import css from './SingularKeyCell.css';

const TAB_PREFIX = `${TRANSLATE_PREFIX}.TRACKING_LINK_OPTIONS_TAB`;

const SingularKeyCell = ({ row, setParam, readOnly, translate }) => {
    const { isCustomRow, index, singular_key: singularKey, duplicateKey, singularKeyInvalidChars } = row;
    if (isCustomRow) {
        let errorMessage = null;
        if (!readOnly) {
            if (singularKeyInvalidChars) {
                errorMessage = translate(`${TRANSLATE_PREFIX}.ERRORS.TRACKING_LINK_PARAM_SINGULAR_KEY_INVALID_CHARS`);
            } else if (duplicateKey) {
                errorMessage = translate(`${TAB_PREFIX}.DUPLICATE_KEY_HINT`);
            }
        }
        return (
            <td>
                <Input
                    value={singularKey}
                    placeholder={readOnly ? undefined : translate(`${TAB_PREFIX}.CUSTOM_PARAM_KEY_PLACEHOLDER`)}
                    onChange={val => setParam(index, 'singular_key', val)}
                    error={errorMessage}
                    disabled={readOnly}
                    required
                />
            </td>
        );
    }
    return (
        <td>
            <code className={css.singularKey}>{singularKey}</code>
        </td>
    );
};

SingularKeyCell.propTypes = {
    row: PropTypes.shape({
        isCustomRow: PropTypes.bool.isRequired,
        index: PropTypes.number.isRequired,
        singular_key: PropTypes.string,
        duplicateKey: PropTypes.bool,
        singularKeyInvalidChars: PropTypes.bool,
    }).isRequired,
    setParam: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default SingularKeyCell;
